<template>
	<div class="header-container">
		<div class="component cloud-header">
			<div class="header-block">
				<div @click="forceReload('/')">
					<img
						class="cloud-logo"
						src="https://assets.che300.com/feimg/cloud/frontend_logo.png"
						alt="云市场logo"
					/>
				</div>
				<div @click="forceReload('/')">
					<div class="header-tab tab-home">首页</div>
				</div>
				<div @click="forceReload('/list')">
					<div class="header-tab tab-product">全部产品</div>
				</div>
				<div class="header-tab tab-product">
					<a :href="WWW_URL + 'cooperator'" target="_blank"
						>申请合作</a
					>
				</div>
				<div class="header-tab tab-product">
					<a :href="WWW_URL + 'about-us'" target="_blank">关于我们</a>
				</div>
			</div>
			<div class="header-block">
				<template v-if="!token">
					<button class="login-btn" @click="goLogin">登录</button>
					<!-- <button class="register-btn" @click="goRegister">
						免费注册
					</button> -->
				</template>
				<template v-if="token">
					<notice :total="userinfo.unread_msg_cnt"></notice>
					<el-dropdown class="avatar-container">
						<div class="avatar-wrapper">
							<img
								src="https://assets.che300.com/feimg/cloud/user_icon_head.png"
								class="user-avatar"
							/>
							<span class="user-name">{{ username }}</span>
							<i class="el-icon-caret-bottom" />
						</div>
						<el-dropdown-menu slot="dropdown" class="user-dropdown">
							<el-dropdown-item :class="verifyStatusClass">
								<span
									style="display:block;text-align:center"
									@click="jump2VerifyResult"
									>{{ verifyText }}</span
								>
							</el-dropdown-item>
							<el-dropdown-item>
								<span
									style="display:block;text-align:center"
									@click="accountInfo"
									>账号信息</span
								>
							</el-dropdown-item>
							<el-dropdown-item>
								<span
									style="display:block;text-align:center"
									@click="orderManage"
									>订单管理</span
								>
							</el-dropdown-item>
							<el-dropdown-item>
								<span
									style="display:block;text-align:center"
									@click="expenditureDetails"
									>收支明细</span
								>
							</el-dropdown-item>
							<el-dropdown-item>
								<span
									style="display:block;text-align:center"
									@click="userLogout"
									>退出</span
								>
							</el-dropdown-item>
						</el-dropdown-menu>
					</el-dropdown>
				</template>
			</div>
		</div>
	</div>
</template>
<script>
import { store, mutations } from "../store/index.js";
import { WWW_URL, LOGIN_URL } from "../utils/constant.js";
import Notice from "@/components/notice";
export default {
	name: "home",
	data() {
		return {
			userDetail: {},
			WWW_URL: WWW_URL,
			verifyText: "",
			verifyStatusClass: "",
			userinfo: {},
			username: ''
		};
	},
	components: {
		Notice
	},
	computed: {
		token() {
			return store.token;
		}
	},
	created() {
		if (this.token) {
			this.getUserInfo();
		}
	},
	methods: {
		// 获取用户信息
		getUserInfo() {
			this.$ax("/api/auth/v1/user/info", {
				headers: {
					Authorization: this.token
				}
			})
				.then(res => {
					const {
						personal_cert_status,
						company_cert_status,
						username
					} = res.data;
					localStorage.setItem('token', this.token)
					localStorage.setItem('username', username)
					this.username= username.length > 5? username.slice(0, 5) + "...": username;
					this.userinfo = res.data;
					this.getVersityStatus(
						personal_cert_status,
						company_cert_status
					);
				})
				.catch(error => {});
		},
		getVersityStatus(personal, company) {
			if (personal === "0" && company === "0") {
				this.verifyText = "未实名认证";
				this.verifyStatusClass = "status__error";
				return;
			}
			if (personal === "110" && company !== "110") {
				this.verifyText = "个人实名已认证";
				this.verifyStatusClass = "status__success";
				return;
			}
			if (personal === "-100" && company === "0") {
				this.verifyText = "个人实名认证失败";
				this.verifyStatusClass = "status__error";
				return;
			}
			if (company === "100" && personal !== "100") {
				this.verifyText = "企业实名认证中";
				this.verifyStatusClass = "status__pending";
				return;
			}
			if (company === "110") {
				this.verifyText = "企业实名已认证";
				this.verifyStatusClass = "status__success";
				return;
			}
			if (company === "-100" && personal !== "100") {
				this.verifyText = "企业实名认证失败";
				this.verifyStatusClass = "status__error";
				return;
			}
		},
		// 退出登录
		userLogout() {
			let me = this
			me.$ax
				.post(
					"/api/auth/logout",
					{},
					{
						headers: {
							Authorization: me.token
						}
					}
				)
				.then(() => {
            		window.exitCookieApi(function(){
						me.clearCookie()
						window.location.reload()
					})
				}).catch(() => {
            		window.exitCookieApi(function(){
						me.clearCookie()
						window.location.reload()
					})
				});
		},
		//退出登陆后的操作
		clearCookie(){
			this.$message.success("退出登录成功");
			// 清除cookie里面的数据
			mutations("login_st");
			mutations("cloud_st");
			//清除掉token的值，让用户状态变回未登录
			mutations("token");
			localStorage.removeItem('token');

			if (this.$route.name === "ProductPay") {
				this.goLogin();
			}else{
				// window.location.href = window.location.origin;
			}
		},
		// 跳转到个人信息
		accountInfo() {
			location.href = "/usercenter#/userinfo";
		},
		// 跳转到订单管理
		orderManage() {
			location.href = "/usercenter#/order-list";
		},
		expenditureDetails() {
			location.href = "/usercenter#/expenditure-details";
		},
		// 跳转到登录页
		goLogin() {
			let url = LOGIN_URL + "?redirect_url=" + encodeURIComponent(location.href);
			location.href = url
				
		},
		// 跳转到个人中心首页
		goUserCenter() {
			location.href = "/usercenter#/dashboard";
		},
		// 前往注册页
		goRegister() {
			if (this.$route.path === "/product-detail") {
				location.href =
					"/#/register?redirect_url=" + encodeURIComponent(location.href);
			} else {
				location.href = "/#/register";
			}
		},
		// 当前路由和目标页面路由相同时，强制刷新一下
		forceReload(target) {
			if (this.$route.path === target) {
				this.$router.go(0);
			} else {
				this.$router.push(target);
			}
		},
		jump2VerifyResult() {
			location.href = "/usercenter#/real-name-authentication";
		}
	}
};
</script>
<style scoped lang="less">
.header-container {
	background-color: #fff;
}
.cloud-header {
	display: flex;
	justify-content: space-between;
	align-items: center;
	height: 60px;
	font-size: 14px;

	.header-block {
		display: flex;
		align-items: center;
		flex-wrap: nowrap;

		.cloud-logo {
			display: inline-block;
			height: 32px;
			cursor: pointer;
		}
		.header-tab {
			color: #222;
			cursor: pointer;
		}
		.tab-home {
			margin-left: 120px;
		}
		.tab-product {
			margin-left: 40px;
		}
		.login-btn {
			color: #222;
			cursor: pointer;
		}
		.register-btn {
			display: inline-flex;
			align-items: center;
			justify-content: center;
			margin-left: 24px;
			width: 80px;
			height: 32px;
			color: #fff;
			background-color: #f60;
			border-radius: 4px;
			cursor: pointer;
		}
	}
	.user-avator {
		display: inline-block;
		width: 32px;
		height: 32px;
		margin-right: 8px;
	}
	.drop-down {
		display: inline-block;
		width: 10px;
		height: 6px;
		margin-left: 8px;
	}
	.user {
		cursor: pointer;
	}
	.avatar-container {
		margin-right: 40px;

		.avatar-wrapper {
			margin-top: 5px;
			position: relative;
			display: flex;
			align-items: center;

			.user-avatar {
				cursor: pointer;
				width: 32px;
				height: 32px;
				border-radius: 10px;
			}
			.user-name {
				display: inline-block;
				max-width: 90px;
				overflow: hidden;
				text-overflow: ellipsis;
				white-space: nowrap;
				cursor: pointer;
				margin: 0 2px 0 8px;
			}

			.el-icon-caret-bottom {
				cursor: pointer;
				position: absolute;
				right: -20px;
				font-size: 12px;
				margin-right: 6px;
			}
		}
	}
}
</style>
<style>
.status__success.el-dropdown-menu__item:not(.is-disabled),
.status__success.el-dropdown-menu__item:not(.is-disabled):hover {
	color: #23cd77 !important;
	background-color: #fff !important;
}
.status__error.el-dropdown-menu__item:not(.is-disabled),
.status__error.el-dropdown-menu__item:not(.is-disabled):hover {
	color: #ff4433 !important;
	background-color: #ffdad6 !important;
}
.status__pending.el-dropdown-menu__item:not(.is-disabled),
.status__pending.el-dropdown-menu__item:not(.is-disabled):hover {
	color: #999 !important;
	background-color: #e5e5e5 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/header.vue